import React from 'react';
import PropTypes from 'prop-types';
import { zeroPad } from 'react-countdown';
import styles from '../../../styles/countdown/countdown.module.scss';

const Timer = ({ hours, minutes, seconds }) => (
  <div className={styles.countdown}>
    <div className={styles.countdownItem}>
      <div className={styles.countdownValue}>{`${zeroPad(hours)}`}</div>
      <div className={styles.countdownDesc}>Hours</div>
    </div>
    <div className={styles.countdownValue}>:</div>
    <div className={styles.countdownItem}>
      <div className={styles.countdownValue}>{`${zeroPad(minutes)}`}</div>
      <div className={styles.countdownDesc}>Minutes</div>
    </div>
    <div className={styles.countdownValue}>:</div>
    <div className={styles.countdownItem}>
      <div className={styles.countdownValue}>{zeroPad(seconds)}</div>
      <div className={styles.countdownDesc}>Seconds</div>
    </div>
  </div>
);

Timer.propTypes = {
  hours: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  minutes: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  seconds: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default Timer;
